import z from "zod";

/**
 * AtributosComprasSchema
 */

export const AtributosComprasSchema = z.object({
  exibirDataCadastro: z.coerce.number().default(1),
  exibirDataCadastroRequisicao: z.coerce.number().default(1),
  exibirDataAprovacaoColetaPreco: z.coerce.number().default(1),
  notaCorte: z.coerce.number(),
  observacoes: z.coerce.string(),
});

/**
 * AtributosComprasForm
 */

export type AtributosComprasForm = z.infer<typeof AtributosComprasSchema>;